import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Snackbar } from '@material-ui/core'
import { useForm } from 'react-form'
import { getUser, setUser } from '../../actions/users'
import Navigation from '../../components/navigation'
import Breadcrumbs from '../../components/breadcrumbs'
import countries from '../../constants/countries'
import Text from '../../components/text'
import Select from '../../components/select'
import './styles.css'

const kvCountries = Object.keys(countries).map(k => ({ value: k, label: countries[k] }))

const FormContent = ({ updated }) => {
  return (
    <>
      <div className="form-group">
        <label htmlFor="firstName">First name</label>
        <Text field="firstName" id="firstName" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="lastName">Last name</label>
        <Text field="lastName" id="lastName" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="email">E-mail</label>
        <Text field="email" id="email" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="phone">Phone</label>
        <Text field="phone" id="phone" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="address1">Address Line 1</label>
        <Text field="address1" id="address1" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="address2">Address Line 2</label>
        <Text field="address2" id="address2" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="city">City</label>
        <Text field="city" id="city" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="zip">ZIP / Postal Code</label>
        <Text field="zip" id="zip" className="form-control" />
      </div>
      <div className="form-group">
        <label htmlFor="country">Country</label>
        <Select field="country" id="country" options={kvCountries} className="form-control mb-4" />
      </div>
      <div className="row">
        <div className="col">
          <button type="submit" className="btn btn-primary">Save</button>
        </div>
        <div className="col" style={{ textAlign: 'right' }}>
          <small>Last saved {moment(updated).fromNow()}</small>
        </div>
      </div>
    </>
  )
}

const Profile = (props) => {
  
  const dispatch = useDispatch()
  const [saving, setSaving] = useState(false)

  const myUserId = useSelector(state => state.cognito.userId)
  const userId = (props.userId === 'me' ? myUserId : props.userId)
  const user = useSelector(state => (state.users.list || {})[userId])

  const handleSave = (submittedValues) => {
    setSaving(true)
    setUser({
      ...submittedValues,
      userId: props.userId
    })(dispatch).then(() => {
      setSaving(false)
    })
  }

  useEffect(() => {
    getUser(props.userId)(dispatch)
  }, [props.userId])

  let updated = -1
  if (user && user.updated) {
    updated = new Date(parseInt(user.updated, 10))
  }

  const { Form, meta: { isSubmitting, canSubmit } } = useForm({
    defaultValues: useMemo(() => user, [user]),
    onSubmit: (submittedValues, instance) => {
      handleSave(submittedValues)
    }
  })

  return (
    <div className='scenes-profile'>
      <Navigation title='Profile' />
      <Breadcrumbs config={[{ url: '/', title: 'Dashboard' }, { title: 'Profile' }]} />
      <div className='box'>
        {user && (
          <Form>
            <FormContent updated={updated} />
          </Form>
        )}
      </div>
      <Snackbar
        open={saving}
        message={'Saving your user profile...'}
        autoHideDuration={4000}
        onClose={() => setSaving(false)} />
    </div>
  )
}

export default Profile
